/**
 * Every whole degree from `ceil(min)` to `floor(max)` inclusive, ascending.
 * Guards `min > max` (returns the single lower bound) so the wheel is never empty.
 */
export function buildTempOptions(min: number, max: number): number[] {
  const lo = Math.ceil(min);
  const hi = Math.floor(max);
  if (!Number.isFinite(lo)) return [];
  if (!Number.isFinite(hi) || lo > hi) return [lo];
  const options: number[] = [];
  for (let v = lo; v <= hi; v++) {
    options.push(v);
  }
  return options;
}

/**
 * Rounds `value` to the nearest whole degree and clamps into `[min, max]`.
 * Non-finite input falls back to `min`.
 */
export function clampTemp(value: number, min: number, max: number): number {
  if (!Number.isFinite(value)) return min;
  return Math.min(max, Math.max(min, Math.round(value)));
}
